export default __webpack_public_path__ + "static/media/tick.e08f7844.gif";